import { Currency } from '../../enums/Currency';
import { SettleOrderStatus } from '../../enums/SettleOrderStatus';
import { TradeType } from '../../enums/TradeType';
import {
    SettleOrder as SettleOrderI,
    SettleOrderDetail as SettleOrderDetailI,
} from '../types/SettleOrder';

export class SettleOrder implements SettleOrderI {
    contractFiles: string[] = [];

    sourceFiles: string[] = [];

    expressFiles: string[] = [];

    orderFiles: string[] = [];

    settleAccountId: number | undefined;

    exchangeAmt?: number | undefined;

    currencyCodeFrom?: Currency | undefined;

    currencyCodeTo?: Currency | undefined;

    fileList?: string[] | undefined;

    tradePassword?: string | undefined;

    fee?: number | undefined;

    tradeType?: TradeType | undefined;

    fileName?: string | undefined;
}

export class SettleOrderDetail implements SettleOrderDetailI {
    contractFiles: string[] = [];

    sourceFiles: string[] = [];

    expressFiles: string[] = [];

    orderFiles: string[] = [];

    id?: number | undefined;

    settleBankCardName?: string | undefined;

    settleBankName?: string | undefined;

    settleBankCardNo?: string | undefined;

    currencyCodeFrom?: Currency | undefined;

    currencyCodeTo?: Currency | undefined;

    exchangeAmt = 0;

    receivedAmt = 0;

    chargeAmt = 0;

    exchangeFee = 0;

    orderNum?: string | undefined;

    swiftCode?: string | undefined;

    status: SettleOrderStatus = SettleOrderStatus.Default;

    createTime?: string | undefined;

    tradeType?: TradeType | undefined;

    remark: string | undefined;

    purchaseOrderUrl: string | undefined;

    exchangeOrderUrl: string | undefined;

    tradeCountType?: string | undefined;

    multipleFile?: string[] = [];
}
